export class VoucherInfo {
  public StatusKindCode?: number;
  public FromStatusKindCode?: number;
  public Id?: number;
  public FiscalYearId: number;
  public VoucherDate: Date;
  public BranchId?: number;
}
